__turbopack_context__.v({
  "averageRating": "AverageRating-module-scss-module__RzWDnq__averageRating",
  "star": "AverageRating-module-scss-module__RzWDnq__star",
  "templatesLength": "AverageRating-module-scss-module__RzWDnq__templatesLength",
});
